import {createReducer, createAction} from 'redux-act';

import {fetchQuoteItemV2} from 'actions/cart/cart';

export type WizardStepType = {
    activeStep: typeof WIZARD_STEPS[number];
    prescriptionStep: Maybe<typeof PRESCRIPTION_STEPS[number]>;
    packagesSubStep: number;
    upgradesSubStep: number;
    usagesSubStep: number;
};

export const initialState: WizardStepType = {
    activeStep: 'usage',
    prescriptionStep: null,
    packagesSubStep: 0,
    upgradesSubStep: 0,
    usagesSubStep: 0,
};

export const setActiveStep = createAction<WizardStepType['activeStep']>('WIZARD_SET_ACTIVE_STEP');
export const setPrescriptionStep = createAction<WizardStepType['prescriptionStep']>(
    'WIZARD_SET_PRESCRIPTION_STEP',
);
export const setPackagesSubStep = createAction<number>(
    'WIZARD_SET_PACKAGES_SUB_STEP',
    number => number,
);
export const setUpgradesSubStep = createAction<number>(
    'WIZARD_SET_UPGRADES_SUB_STEP',
    number => number,
);
export const setUsagesSubStep = createAction<number>('WIZARD_SET_USAGES_SUB_STEP');
export const resetSteps = createAction('WIZARD_RESET_STEPS');

export const WIZARD_STEPS = ['usage', 'prescription', 'lens', 'upgrades', 'summary'] as const;

export const FILL_IT_OUT_ONLINE_STEP = 'fill_it_out_online';
export const USE_SAVED_STEP = 'use_saved';
export const PRESCRIPTION_UPLOAD_STEP = 'upload';
export const PRESCRIPTION_STEPS = [
    FILL_IT_OUT_ONLINE_STEP,
    USE_SAVED_STEP,
    PRESCRIPTION_UPLOAD_STEP,
] as const;

/**
 * Determines state of active wizard step
 */
export const wizardStep = createReducer<WizardStepType>({}, initialState)
    .on(`${setActiveStep}`, (state, activeStep: WizardStepType['activeStep']) => ({
        ...state,
        activeStep,
        ...(activeStep === 'usage' ? {prescriptionStep: null} : {}),
    }))
    .on(
        `${setPrescriptionStep}`,
        (state, prescriptionStep: WizardStepType['prescriptionStep']) => ({
            ...state,
            prescriptionStep,
        }),
    )
    .on(`${fetchQuoteItemV2}_FULFILLED`, state => ({
        ...state,
        activeStep: 'summary',
        upgradesSubStep: 1,
        packagesSubStep: 1,
    }))
    .on(`${setPackagesSubStep}`, (state, payload: number) => ({...state, packagesSubStep: payload}))
    .on(`${setUsagesSubStep}`, (state, payload: number) => ({...state, usagesSubStep: payload}))
    .on(`${setUpgradesSubStep}`, (state, payload: number) => ({
        ...state,
        upgradesSubStep: payload,
    }))
    .on(`${resetSteps}`, () => initialState);
